module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "collect-coupon"
  }, [(_vm.couponType) ? _c('div', {
    staticClass: "coupon-type"
  }, [_c('div', {
    staticClass: "coupon-name"
  }, [_vm._v(_vm._s(_vm.couponType.name))]), _vm._v(" "), _c('div', {
    staticClass: "coupon-info"
  }, [_c('div', {
    staticClass: "flex"
  }, [(_vm.couponType.thumbnail) ? _c('div', {
    staticClass: "flex-1"
  }, [_c('img', {
    attrs: {
      "src": _vm.UPLOAD_DOMAIN + _vm.couponType.thumbnail + '?x-oss-process=image/resize,w_120',
      "default-src": "static/placeholder.png",
      "container": ".collectBox"
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "flex-1"
  }, [(_vm.couponType.type == 'free') ? _c('div', [_vm._v("免费兑换")]) : _vm._e(), _vm._v(" "), (_vm.couponType.type == 'cash-off') ? _c('div', [_vm._v("\n                        满￥" + _vm._s(_vm._f("fen2yuan")(_vm.couponType.cashOffLimit)) + "减￥" + _vm._s(_vm._f("fen2yuan")(_vm.couponType.cashOffValue)) + "\n                    ")]) : _vm._e(), _vm._v(" "), (_vm.couponType.type == 'rate-off') ? _c('div', [_vm._v("\n                        满" + _vm._s(_vm.couponType.rateOffLimit) + "件打" + _vm._s(_vm.couponType.rateOffValue) + "折\n                    ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "coupon-date"
  }, [_vm._v("有效期至：" + _vm._s(_vm._f("date")(_vm.couponType.expirationDate)))]), _vm._v(" "), _c('div', {
    staticClass: "coupon-date"
  }, [_vm._v("每人限领：" + _vm._s(_vm.couponTypeCollected) + "/" + _vm._s(_vm.couponType.collectLimit) + "张")]), _vm._v(" "), _c('div', {
    staticClass: "coupon-date"
  }, [_vm._v("剩余：" + _vm._s(_vm.couponType.stock) + "/" + _vm._s(_vm.couponType.totalStock) + "张")]), _vm._v(" "), _c('x-button', {
    staticClass: "collect-coupon-btn",
    attrs: {
      "mini": "",
      "disabled": _vm.invalidCoupon,
      "type": "success"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.addCoupon($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.couponBtnText))])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "couponlist-link"
  }, [_c('router-link', {
    attrs: {
      "to": "/userCenter/couponList"
    }
  }, [_vm._v("我的优惠券")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/shoppCart"
    }
  }, [_vm._v("去购物车结算")])], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "coupon-product-title"
  }, [_vm._v("优惠商品")]), _vm._v(" "), _c('div', {
    staticClass: "commdity flex"
  }, [(_vm.couponType && _vm.couponType.products) ? _c('div', {
    staticClass: "box2"
  }, _vm._l((_vm.couponType.products), function(product, index) {
    return _c('div', {
      key: product._id,
      staticClass: "commodity flex vux-1px-b",
      on: {
        "click": function($event) {
          _vm.toDetail(product._id)
        }
      }
    }, [_c('div', {
      staticClass: "img",
      class: 'img-' + index
    }, [_c('img', {
      attrs: {
        "src": _vm.UPLOAD_DOMAIN + product.thumbnail + '?x-oss-process=image/resize,w_120',
        "default-src": "static/placeholder.png",
        "container": ".collectBox"
      }
    })]), _vm._v(" "), _c('transition', {
      attrs: {
        "name": "pic"
      },
      on: {
        "after-enter": function($event) {
          _vm.listIndex = -1
        }
      }
    }, [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (index == _vm.listIndex),
        expression: "index==listIndex"
      }],
      staticClass: "img img2"
    }, [_c('img', {
      attrs: {
        "src": _vm.UPLOAD_DOMAIN + product.thumbnail + '?x-oss-process=image/resize,w_120',
        "default-src": "static/placeholder.png",
        "container": ".collectBox"
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "commodity-r "
    }, [_c('span', {
      staticClass: "ellipsis-2"
    }, [_vm._v(_vm._s(product.title)), (product.specLabel) ? _c('span', [_vm._v("(" + _vm._s(product.specLabel) + ")")]) : _vm._e(), (product.areaLimit) ? _c('span', [_vm._v("(限售湖北)")]) : _vm._e()]), _vm._v(" "), _c('b', {
      staticClass: "red"
    }, [_vm._v("￥" + _vm._s(_vm._f("fen2yuan")(product.price)))])]), _vm._v(" "), _c('div', {
      staticClass: "add-cart",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.addCart(product._id, product.category, 'img-' + index, _vm.UPLOAD_DOMAIN + product.thumbnail + '?x-oss-process=image/resize,w_120')
        }
      }
    }, [_c('i', {
      staticClass: "icon-jia iconfont text-center"
    })])], 1)
  })) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-74b62228"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/UserCenter/addCoupon/collectCoupon.vue
// module id = 583
// module chunks = 0